var map = {
	"./Test.svg": 1430,
	"./arrowNext.svg": 8784,
	"./arrow_back.svg": 4897,
	"./bankCards/alfa-card.svg": 9070,
	"./bankCards/raiffeisen-card.svg": 6730,
	"./bankCards/sber-card.svg": 395,
	"./bankCards/sbp-card.svg": 7874,
	"./bankCards/tinkoff-card.svg": 6483,
	"./close.svg": 5289,
	"./copy.svg": 935,
	"./currency/BTC.svg": 4858,
	"./currency/BUSD.svg": 2964,
	"./currency/CHF.svg": 2089,
	"./currency/CNY.svg": 525,
	"./currency/ETH.svg": 2200,
	"./currency/EUR.svg": 7194,
	"./currency/GBP.svg": 9485,
	"./currency/INR.svg": 9855,
	"./currency/JPY.svg": 5950,
	"./currency/KPW.svg": 7647,
	"./currency/RUB.svg": 9538,
	"./currency/TRX.svg": 1915,
	"./currency/USD.svg": 8367,
	"./currency/USDT.svg": 1262,
	"./deposit.svg": 57,
	"./ellipseDownLogin.svg": 4422,
	"./ellipseUpLogin.svg": 6837,
	"./export.svg": 5349,
	"./logo.svg": 8092,
	"./new/benefits_bg.svg": 645,
	"./new/cancel.svg": 5999,
	"./new/card-icon.svg": 4560,
	"./new/choose-bank-icon.svg": 2290,
	"./new/copy-icon.svg": 6128,
	"./new/done.svg": 2950,
	"./new/form_bg.svg": 6248,
	"./new/fragment_four.svg": 5068,
	"./new/fragment_one.svg": 784,
	"./new/fragment_three.svg": 3098,
	"./new/fragment_two.svg": 8518,
	"./new/hero.svg": 7053,
	"./new/hero_bg_first.svg": 2523,
	"./new/hero_bg_second.svg": 9323,
	"./new/hero_left.svg": 1558,
	"./new/login_frame.svg": 6932,
	"./new/login_frame_mobile.svg": 1747,
	"./new/payment-cancellation.svg": 9487,
	"./new/replenishment.svg": 6099,
	"./new/successful-payment.svg": 8555,
	"./new/tick.svg": 2284,
	"./new/warning.svg": 923,
	"./payments/bitcoin.svg": 2191,
	"./payments/etherium.svg": 7269,
	"./payments/mastercard.svg": 2345,
	"./payments/sepa.svg": 9084,
	"./payments/swift.svg": 8962,
	"./payments/thron.svg": 7516,
	"./payments/unionPay.svg": 3830,
	"./payments/visa.svg": 2033,
	"./privacyPolicy_left.svg": 5855,
	"./privacyPolicy_left_two.svg": 8472,
	"./privacyPolicy_right_two.svg": 4642,
	"./refund_cursor.svg": 7031,
	"./search.svg": 3655,
	"./view_details_cursor.svg": 1266
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 8278;